<template>
  <div class="login" @keyup.enter="Login">
    <div class="signBox">
      <div class="title">巡店任务管理系统</div>
      <el-form
        class="demo-ruleForm"
        v-bind:model="ruleForm"
        status-icon=""
        v-bind:rules="rules"
        ref="form"
        label-width="0px"
      >
        <el-form-item label="" prop="cellphone">
          <span>用户名</span>
          <el-input
            type="text"
            v-model="ruleForm.cellphone"
            autocomplete="off"
            placeholder="请输入用户名"
            size="smail"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="password">
          <span>密码</span>
          <el-input
            type="password"
            v-model="ruleForm.password"
            autocomplete="off"
            placeholder="请输入密码"
            size="smail"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="success"
            style="width: 100%;margin-top: 20px"
            @click="Login"
          >
            登录
          </el-button>
        </el-form-item>
        <el-checkbox label="记住用户名" v-model="remember"></el-checkbox>
      </el-form>
    </div>
  </div>
</template>
<script>
import md5 from "md5";
import CryptoJS from 'crypto-js'

export default {
  name: "Login",
  data() {
    const validateCellphone = (rule, value, callback) => {
      if (value) callback();
      else callback(new Error("请输入用户名!"));
    };

    const validatePassword = (rule, value, callback) => {
      if (value) callback();
      else callback(new Error("请输入密码!"));
    };

    let cellphone = "";

    const remember = (() => {
      let remember = localStorage.remember
        ? JSON.parse(localStorage.remember)
        : false;
      if (remember) cellphone = localStorage.cellphone;
      return remember;
    })();

    return {
      remember,
      ruleForm: { cellphone, password: "" },
      rules: {
        cellphone: [{ validator: validateCellphone, trigger: "blur" }],
        password: [{ validator: validatePassword, trigger: "blur" }]
      }
    };
  },
  methods: {
    getFirstMenuKey (menu) {
      if (menu.hasSubMenu) {
        return menu.subMenuList[0].url + '-' + menu.subMenuList[0].menuCode
      } else {
        return menu.url + '-' + menu.menuCode
      }
    },
    Login() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          // let password = md5(this.ruleForm.password);
          let password = CryptoJS.SHA256(md5(this.ruleForm.password)).toString()
          let ruleForm = { ...this.ruleForm, password };
          let LoginResult = await axios.post(oprReqUrl+"account/login", ruleForm);
          LoginResult = LoginResult.data;
          if (LoginResult.code !== 200){
            this.$message.warning(LoginResult.message)
            return false;
          }
          this.$store.commit("setToken", LoginResult.data.token);
          // let AccountResult = await axios.post("account/getAccount");
          // AccountResult = AccountResult.data;
          // if (AccountResult.code !== 200) return false;
          this.$store.commit("setAccount", LoginResult.data.Account.ccount);
          localStorage.cellphone = ruleForm.cellphone;
          localStorage.remember = this.remember;
          // LoginResult.data.menuList
          localStorage.setItem("oprMenuData", JSON.stringify(LoginResult.data.menuList))
          localStorage.setItem("menuViewData", LoginResult.data.reportFlag)
          localStorage.setItem("userName", LoginResult.data.Account.name)
          // this.$store.commit("menuData", LoginResult.data.menuList)
          console.log('first', LoginResult.data.menuList[0])
          const indexMenu = this.getFirstMenuKey(LoginResult.data.menuList[0])
          let [menuKey, menuCode] = indexMenu.split('-');
          console.log('menuKey', menuKey)
          this.$router.push({path: "/pages/" + menuKey});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="sass" scoped>
.login
  height: 100vh
  width: 100vw
  background: #EEEEEE
  overflow: hidden
  .signBox
    width: 240px
    padding: 20px
    position: absolute
    left: 50%
    top: 50%
    transform: translate(-50%, -50%)
    .title
      color: #6F6F6F
      font-size: 26px
      font-weight: 600
      letter-spacing: 2px
      text-align: center
      margin-bottom: 30px
</style>



// WEBPACK FOOTER //
// src/opr/components/Login.vue